"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTONUMBER_LABEL_MAX_LENGTH = void 0;
exports.AUTONUMBER_LABEL_MAX_LENGTH = 20;
